<header class="header">
	<div class="header__container flex justify-center py-2.5">
		<img class="header__logo" [src]="brandLogo" alt="brand logo">
	</div>
</header>

<div class="container-fluid">

	<div style="margin:auto; font-weight:500; max-width: 700px; text-align:center; line-height: 32px; padding: 16px;">
        <p>Oops! We had a technical error. Our team is working to fix it right now.</p>
        <p>In the meantime, please call {{PHONE_NUMBER_AREA_CODE}}-{{PHONE_NUMBER_WITHOUT_AREA_CODE}} to ensure your order processed correctly.</p>
        <p>We apologize for any inconvenience. Thank you for joining the Activated You family!</p>
	</div>
	
</div>